// extracted by mini-css-extract-plugin
export default {"paginationContainer":"PaginationComponent_paginationContainer__1XwlJ"};